import React, { Fragment } from "react";

const Applied = ({
  isAuthenticated,
  applicant,
  user: { avatar, firstname, lastname, jobtitle, location },
  attachmentFile,
  setAttachmentFile,
  clearJobs,
  jobId,
  jobChannelId,
  deleteApplication,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box-light">
          <i
            className="fas fa-times fa-3x message-x-dark"
            onClick={() => {
              clearJobs();
              setAttachmentFile({ file: "", email: "" });
            }}
          ></i>
          {isAuthenticated && (
            <div className="flex-center">
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="drop-down-result-avi"
                    alt="avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="black name-font bold">
                      {firstname} {lastname}
                    </span>
                  </li>
                  <li className="user-online-item-dark">{jobtitle}</li>
                  <li className="user-online-item-dark">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
          )}
          {!isAuthenticated && (
            <div className="flex-center">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="black name-font bold">
                      {attachmentFile.email}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          )}
          <div className="user-request-text-light">
            <i className="fas fa-exclamation-circle fa-lg red mr-5"></i>
            {applicant.msg}
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-red"
              onClick={() => {
                deleteApplication(attachmentFile.email, jobChannelId, jobId);
                setAttachmentFile({ file: "", email: "" });
              }}
            >
              <i className="fas fa-times fa-sm mr-5"></i>
              Withdraw Application
            </button>
            <button
              className="user-request-button background-dark-black white"
              onClick={() => {
                clearJobs();
                setAttachmentFile({ file: "", email: "" });
              }}
            >
              <i className="fas fa-times fa-sm mr-5"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Applied;
